import { getFromLS } from '@orientaction/utils';
import { useState } from 'react';
import { createTestReview } from '../services/Analytics.service';

const useFeedbackSubmit = (testId: string) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submitFeedback = async (rating: number, comment: string) => {
    setIsSubmitting(true);
    setError(null);

    try {
      const token = getFromLS('userToken');
      if (!token) {
        throw new Error('Token non trouvé');
      }

      await createTestReview(token, {
        test: testId,
        note: rating,
        comment,
      });

      return true;
    } catch (err: any) {
      const errorMessage =
        err?.response?.data?.error?.message ||
        "Une erreur est survenue lors de l'envoi de votre avis";
      setError(errorMessage);
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  const reset = () => {
    setError(null);
    setIsSubmitting(false);
  };

  return { submitFeedback, isSubmitting, error, reset };
};

export default useFeedbackSubmit;
